import { render, staticRenderFns } from "./CitiesBlock.vue?vue&type=template&id=f485daba"
import script from "./CitiesBlock.vue?vue&type=script&lang=ts"
export * from "./CitiesBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports